<template>
  <v-tabs v-model="tabMenu">
    <v-tabs-slider color="primary"></v-tabs-slider>
    <v-tab @click="resetTab()">Standard Risk Text</v-tab>
    <v-tab v-show="stdRiskTxtTab" @click="resetTab(2)">{{ ids.riskNo != 'new' ? 'Text Info / Item Text List': 'New Standard Risk Text'}}</v-tab>
    <v-tab v-show="stdItemTxtTab" @click="resetTab(3)">{{ ids.itemNo != 'new' ? 'Item Text Info / SubItem Text List': 'New Standard Risk Item Text'}}</v-tab>
    <v-tab v-show="stdSubItemTxtTab">{{ ids.stdRiskTxt != 'new' ? 'SubItem Text Info': 'New Standard Risk SubItem Text'}}</v-tab>
    <v-tab-item>
      <std-risk-txt-list :fetchRisk="fetchRisk" :scheme="scheme" @doNew="doRiskNew" @doReview="doRiskReview"></std-risk-txt-list>
    </v-tab-item>
    <v-tab-item>
      <std-risk-txt-form :ids="ids" @resetTab="resetTab"></std-risk-txt-form>
      <std-item-txt-list :fetchItem="fetchItem" v-if="ids.riskNo !== 'new'" :ids="ids" @doNew="doItemNew" @doReview="doItemReview"></std-item-txt-list>
    </v-tab-item>
    <v-tab-item>
      <std-item-txt-form :ids="ids" @resetTab="resetTab"></std-item-txt-form>
      <std-sub-item-txt-list :fetchSubItem="fetchSubItem" v-if="ids.itemNo !== 'new'" :ids="ids" @doNew="doSubItemNew" @doReview="doSubItemReview"></std-sub-item-txt-list>
    </v-tab-item>
    <v-tab-item>
      <std-sub-item-txt-form :ids="ids" @resetTab="resetTab"></std-sub-item-txt-form>
    </v-tab-item>
  </v-tabs>
</template>

<script>
import StdRiskTxtList from './stdRiskTxt/list/StdRiskTxtList'
import StdItemTxtList from './stdRiskTxt/list/StdItemTxtList'
import StdSubItemTxtList from './stdRiskTxt/list/StdSubItemTxtList'
import StdRiskTxtForm from './stdRiskTxt/form/StdRiskTxtForm'
import StdItemTxtForm from './stdRiskTxt/form/StdItemTxtForm'
import StdSubItemTxtForm from './stdRiskTxt/form/StdSubItemTxtForm'
export default {
  data() {
    return {
      tabMenu: 0,
      stdRiskTxtTab: false,
      stdItemTxtTab: false,
      stdSubItemTxtTab: false,
      fetchRisk: false,
      fetchItem: false,
      fetchSubItem: false,
      ids: {
        scheme: null,
        riskNo: null,
        itemNo: null,
        subItemNo: null,
        stdRiskTxt: null
      }
    }
  },
  computed: {
    schemeMenu() {
      return this.$store.state.parameters.scheme.schemeMenu
    }
  },
  methods: {
    async resetTab(tab) {
      switch (tab) {
        case 3: {
          this.tabMenu = 2
          this.ids.subItemNo = null
          this.stdRiskTxtTab = true
          this.stdItemTxtTab = true
          this.stdSubItemTxtTab = false
          this.fetchRisk = false
          this.fetchItem = false
          this.fetchSubItem = true
          break
        }
        case 2: {
          this.tabMenu = 1
          this.ids.itemNo = null
          this.stdRiskTxtTab = true
          this.stdItemTxtTab = false
          this.stdSubItemTxtTab = false
          this.fetchRisk = false
          this.fetchItem = true
          this.fetchSubItem = false
          break
        }
        default: {
          this.tabMenu = 0
          this.ids.riskNo = null
          this.stdRiskTxtTab = false
          this.stdItemTxtTab = false
          this.stdSubItemTxtTab = false
          this.fetchRisk = true
          this.fetchItem = false
          this.fetchSubItem = false
        }
      }
    },
    async doInit() {
      this.ids.scheme = this.scheme
      await this.$store.dispatch('schemeMenuInit', this.scheme)
    },
    doRiskReview(data) {
      this.tabMenu = 1
      this.ids.riskNo = data.riskNo
      this.stdRiskTxtTab = true
      this.stdItemTxtTab = false
      this.stdSubItemTxtTab = false
      this.fetchRisk = false
      this.fetchItem = true
      this.fetchSubItem = false
    },
    doRiskNew() {
      this.tabMenu = 1
      this.ids.riskNo = 'new'
      this.stdRiskTxtTab = true
      this.stdItemTxtTab = false
      this.stdSubItemTxtTab = false
      this.fetchRisk = false
      this.fetchItem = false
      this.fetchSubItem = false
    },
    doItemReview(data) {
      this.tabMenu = 2
      this.ids.itemNo = data.itemNo
      this.ids.stdRiskTxt = data.stdRiskTxt
      this.stdRiskTxtTab = true
      this.stdItemTxtTab = true
      this.stdSubItemTxtTab = false
      this.fetchRisk = false
      this.fetchItem = false
      this.fetchSubItem = true
    },
    doItemNew(data) {
      this.tabMenu = 2
      this.ids.itemNo = 'new'
      this.ids.stdRiskTxt = data
      this.stdRiskTxtTab = true
      this.stdItemTxtTab = true
      this.stdSubItemTxtTab = false
      this.fetchRisk = false
      this.fetchItem = false
      this.fetchSubItem = false
    },
    doSubItemReview(data) {
      this.tabMenu = 3
      this.ids.subItemNo = data.subItemNo
      this.stdRiskTxtTab = true
      this.stdItemTxtTab = true
      this.stdSubItemTxtTab = true
      this.fetchRisk = false
      this.fetchItem = false
      this.fetchSubItem = false
    },
    doSubItemNew() {
      this.tabMenu = 3
      this.ids.subItemNo = 'new'
      this.stdRiskTxtTab = true
      this.stdItemTxtTab = true
      this.stdSubItemTxtTab = true
      this.fetchRisk = false
      this.fetchItem = false
      this.fetchSubItem = false
    }
  },
  mounted() {
    this.ids.scheme = this.scheme
    Promise.all([this.doInit()])
  },
  components: {
    StdRiskTxtList,
    StdItemTxtList,
    StdSubItemTxtList,
    StdRiskTxtForm,
    StdItemTxtForm,
    StdSubItemTxtForm
  },
  props: {
    scheme: {
      type: String,
      default: ''
    }
  }
}
</script>

<style>

</style>
